import React from 'react';
import ReactSelect from 'react-select';

// --- Стили для светлой и тёмной темы ---
const lightStyles = {
  control: (base) => ({
    ...base,
    minHeight: '42px',
    background: 'var(--tg-theme-bg-color, #fff)',
    borderColor: 'rgba(153, 153, 153, 0.5)',
    '&:hover': {
      borderColor: 'var(--tg-theme-button-color, rgba(36, 129, 204, 0.9))'
    }
  }),
  option: (base, state) => ({
    ...base,
    background: state.isSelected
      ? 'var(--tg-theme-button-color, rgba(36, 129, 204, 0.9))'
      : state.isFocused
        ? 'rgba(36, 129, 204, 0.1)'
        : 'transparent',
    color: state.isSelected
      ? 'var(--tg-theme-button-text-color, #fff)'
      : 'var(--tg-theme-text-color, #000)'
  }),
  menu: (base) => ({
    ...base,
    background: 'var(--tg-theme-bg-color, #fff)',
    zIndex: 2
  }),
  input: (base) => ({
    ...base,
    color: 'var(--tg-theme-text-color, #000)',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none'
  })
};

const darkStyles = {
  control: (base) => ({
    ...base,
    minHeight: '42px',
    background: 'rgba(45,45,45,0.95)',
    color: '#fff',
    borderColor: 'rgba(153,153,153,0.3)',
  }),
  option: (base, state) => ({
    ...base,
    background: state.isSelected
      ? 'var(--tg-theme-button-color, #2481cc)'
      : state.isFocused
        ? '#333'
        : 'rgba(45,45,45,0.95)',
    color: '#fff',
  }),
  menu: (base) => ({
    ...base,
    background: 'rgba(45,45,45,0.95)',
    color: '#fff',
    zIndex: 2
  }),
  singleValue: (base) => ({
    ...base,
    color: '#fff',
  }),
  input: (base) => ({
    ...base,
    color: '#fff',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none'
  }),
  placeholder: (base) => ({
    ...base,
    color: '#aaa',
  }),
};

const lightTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: 'var(--tg-theme-button-color, rgba(36, 129, 204, 0.9))',
    primary25: 'rgba(36, 129, 204, 0.1)',
    neutral0: 'var(--tg-theme-bg-color, #fff)',
    neutral80: 'var(--tg-theme-text-color, #000)'
  }
});
const darkTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: 'var(--tg-theme-button-color, #2481cc)',
    primary25: '#333',
    neutral0: 'rgba(45,45,45,0.95)',
    neutral80: '#fff',
    neutral20: 'rgba(153,153,153,0.3)',
    neutral30: '#2481cc',
    neutral60: '#aaa',
    neutral90: '#fff',
  }
});

function isDarkTheme() {
  // Проверяем Telegram.WebApp.colorScheme или data-theme на html
  if (window.Telegram?.WebApp?.colorScheme) {
    return window.Telegram.WebApp.colorScheme === 'dark';
  }
  return document.documentElement.getAttribute('data-theme') === 'dark';
}

const Select = ({ options, value, onChange, placeholder, isMulti = false, isSearchable = true, isClearable = true, isReadOnly = false }) => {
  const dark = isDarkTheme();
  return (
    <div className="select-container">
      <ReactSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isMulti={isMulti}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isReadOnly={isReadOnly}
        styles={dark ? darkStyles : lightStyles}
        theme={dark ? darkTheme : lightTheme}
      />
    </div>
  );
};

export default Select; 